import { useNavigate } from 'react-router-dom';
import { useIndexedDBSyncV2 } from '../../../../database/dataLocal/indexedDBHooks';
import useQueries from '../../../../database/useQueries';
import { Box, Grid, IconButton, Tooltip, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { BtnCreateBurial } from './accessoriesStyles';
import EditIcon from '@mui/icons-material/Edit';
import ConfirmationDialogOnlyOk from '../../plagins/dialogs/ConfirmationDialogOnlyOk';
import DeleteIcon from '@mui/icons-material/Delete';
import { useContext } from 'react';
import { GlobalContext } from '../../../../App';
import { DataContext } from '../../pagesMains/GravesManagers/Graves';
import { createFetchDataServer, getTableData } from '../../../../database/fetchData';

export const TabContentColumnsBurial = ({ grave, purchase, burial, columns }) => {
  const navigate = useNavigate();

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const { token, permission } = useContext(GlobalContext);

  const myPermissions = [1];

  // טעינת היוזים לפונקציות עזר
  const { removeBurial } = useQueries();

  const [openAnswer, setOpenAnswer] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true); // מצב טעינה

  const editItem = () => {
    navigate('/burialUpdate', { state: { grave: grave, value: burial } });
  };

  const deleteItem = () => {
    setOpenAnswer(true);
    setTitle('מחיקת קבורה');
    setContent('האם את/ה בטוח/ה למחוק את הקבורה?');
  };

  // מחיקת קבורה - בפועל
  const handleAnswer = (answer) => {
    setOpenAnswer(false);
    if (answer) {
      async function executeQueries() {
        try {
          // שאילתה ראשונה
          let resAddOrUpdateDataBurial = removeBurial({...burial});

          // מחכה לכל השאילתות ביחד
          let results = await Promise.all([resAddOrUpdateDataBurial]);

          // בודק אם כל התשובות הן 200
          if (results.every((res) => res === 200)) {
            // פעולות לאחר הצלחה
            // navigate(-1);
          } else {
            // טיפול במקרה של כישלון
            console.error('אחת או יותר מהשאילתות נכשלה');
          }
        } catch (error) {
          console.error('שגיאה בביצוע השאילתות:', error);
        }
      }

      executeQueries();
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCustomers = localTempData.find((item) => item.name === 'dataCustomers');
        const dataPurchases = localTempData.find((item) => item.name === 'dataPurchases');
        const dataGraves = localTempData.find((item) => item.name === 'dataGraves');
        if (dataGraves && dataCustomers && dataPurchases) {
          setLoading(false);
        }
      }
      else {
        fetchDataServer(['customers', 'purchases'], token);
      }
    }
    loadTableData();
  }, []);

  if (columns?.length > 0) {
    return (
      <Grid
        container
        direction="column"
        style={{
          height: '100%',
          position: 'relative' // כדי לאפשר מיקום אבסולוטי של האייקונים
        }}>
        {/* גריד עליון */}
        <Grid item style={{ flex: 1 }}>
          <Grid container spacing={2}>
            {columns.map((column, index) => {
              return (
                <Grid item xs={4} key={index}>
                  <Box sx={{ textAlign: 'left' }}>
                    {column && (
                      <Typography color="textSecondary">
                        <span style={{ fontWeight: 'bold' }}>{column?.title}</span>
                        <span>{`: `}</span>
                        <span>{column?.value}</span>
                      </Typography>
                    )}
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Grid>

        {/* אייקונים של עריכה ומחיקה בפינה העליונה השמאלית */}
        <Box
          sx={{
            position: 'absolute',
            bottom: 8,
            right: 8,
            display: 'flex',
            gap: 1
          }}>
          {(permission === 0 ? true : myPermissions.includes(permission)) && (
            <>
              <Tooltip title="עריכה">
                <IconButton onClick={editItem} sx={{ color: 'lightblue' }}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title="מחיקה">
                <IconButton onClick={deleteItem} sx={{ color: 'lightcoral' }}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Box>

        {/* גריד תחתון */}
        <Grid item></Grid>

        {/* דיאלוג להעברת בעלות */}
        <ConfirmationDialogOnlyOk open={openAnswer} content={content} onAnswer={handleAnswer} />
      </Grid>
    );
  } else {
    return <>
    <BtnCreateBurial graveId={grave} />;
    </>
  }
};
